// extracted by mini-css-extract-plugin
module.exports = {"PhotoTitleEditForm__submitBtn":"jl_a bhh_rm","PhotoTitleEditForm__cancelBtn":"jl_b bhh_rq bhh_rp"};